import { useState } from 'react';

export default function LoginPage({ setupRequired, onSubmit }) {
  const [form, setForm] = useState({
    username: 'admin',
    password: '',
    openai_api_key: '',
    default_model: 'gpt-5.2-codex',
  });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await onSubmit(form);
    } catch (err) {
      setError(err.message || 'Request failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-deep)', display: 'grid', placeItems: 'center', padding: '24px' }}>
      <div style={{ width: '100%', maxWidth: '460px', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '18px', padding: '32px' }}>
        <div style={{ fontFamily: 'var(--font-display)', fontSize: '32px', fontWeight: '800', marginBottom: '8px' }}>
          GEO<span style={{ color: 'var(--accent)' }}>-SEO</span>
        </div>
        <div style={{ color: 'var(--text-3)', marginBottom: '28px', fontSize: '14px' }}>
          {setupRequired ? 'First-time setup: create the admin account and save your OpenAI key.' : 'Sign in to access saved GEO projects and run history.'}
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '16px' }}>
          <Field label="Username">
            <input value={form.username} onChange={(e) => setForm((prev) => ({ ...prev, username: e.target.value }))} style={inputStyle} />
          </Field>

          <Field label="Password">
            <input type="password" value={form.password} onChange={(e) => setForm((prev) => ({ ...prev, password: e.target.value }))} style={inputStyle} />
          </Field>

          {setupRequired && (
            <>
              <Field label="OpenAI API Key">
                <input type="password" value={form.openai_api_key} onChange={(e) => setForm((prev) => ({ ...prev, openai_api_key: e.target.value }))} style={inputStyle} placeholder="sk-..." />
              </Field>
              <Field label="Default Model">
                <select value={form.default_model} onChange={(e) => setForm((prev) => ({ ...prev, default_model: e.target.value }))} style={inputStyle}>
                  {['gpt-5.2-codex', 'gpt-5.2', 'gpt-5-mini', 'gpt-4.1', 'gpt-4.1-mini', 'gpt-4o', 'gpt-4o-mini'].map((model) => (
                    <option key={model} value={model}>{model}</option>
                  ))}
                </select>
              </Field>
            </>
          )}

          {error && <div style={{ color: 'var(--poor)', fontSize: '13px', fontFamily: 'var(--font-mono)' }}>{error}</div>}

          <button type="submit" disabled={busy} style={{ ...buttonStyle, opacity: busy ? 0.7 : 1 }}>
            {busy ? 'Working...' : setupRequired ? 'Create Admin Account' : 'Log In'}
          </button>
        </form>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label style={{ display: 'grid', gap: '8px' }}>
      <span style={{ fontSize: '11px', color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '1px', fontFamily: 'var(--font-mono)' }}>{label}</span>
      {children}
    </label>
  );
}

const inputStyle = {
  width: '100%',
  padding: '12px 14px',
  background: 'var(--bg-surface)',
  border: '1px solid var(--border)',
  borderRadius: '10px',
  color: 'var(--text-1)',
  fontSize: '14px',
  outline: 'none',
};

const buttonStyle = {
  padding: '13px 16px',
  background: 'var(--accent)',
  border: 'none',
  borderRadius: '10px',
  color: '#08110e',
  fontSize: '14px',
  fontWeight: '700',
  fontFamily: 'var(--font-display)',
  cursor: 'pointer',
};
